export default __webpack_public_path__ + "static/workflow-cull-f18fa2e629be11df215b8d2be52533dd.png";